import DualRangeSlider from "./DualRangeSlider.jsx";
import { useTranslation } from "react-i18next";

const FilterModal = ({
  showModal,
  onClose,
  onApplyFilters,
  totalCount,
  filters,
  setFilters,
  handleCityChange,
  handleNearbySearchToggle,
  handleCategoryClick,
  resetFilters,
  showResults,
  iconData,
}) => {
  const { t } = useTranslation();

  //console.log("show results", filters);

  const handleMinPriceChange = (input) => {
    const value =
      typeof input === "object" ? Number(input.target.value) : input;
    setFilters((prevFilters) => ({
      ...prevFilters,
      selectedPriceRange: {
        ...prevFilters.selectedPriceRange,
        min: Math.min(value, prevFilters.selectedPriceRange.max - 100),
      },
    }));
  };

  const handleMaxPriceChange = (input) => {
    const value =
      typeof input === "object" ? Number(input.target.value) : input;

    setFilters((prevFilters) => ({
      ...prevFilters,
      selectedPriceRange: {
        ...prevFilters.selectedPriceRange,
        max: Math.min(value, 3000),
      },
    }));
  };

  return (
    <>
      {showModal && (
        <div
          className="modal-backdrop fixed inset-0 bg-black opacity-50 z-40"
          onClick={onClose}
        ></div>
      )}

      <div
        className={`modal fixed inset-0 flex items-end justify-center z-50 transform transition-transform duration-10 ${
          showModal ? "translate-y-0" : "translate-y-full"
        }`}
      >
        <div className="modal-content bg-white p-6 rounded-t-lg shadow-lg w-full h-3/4 md:w-full md:h-1/2 relative">
          <h2 className="text-lg font-semibold mb-4">{t("Filter Houses")}</h2>

          <label className="text">
            {t("Selected house type")}:
            <b style={{ color: "#6938ef" }}>{filters.selectedHouseType}</b>
          </label>

          <div className="flex overflow-x-auto space-x-4 p-4 scrollbar-hide">
            {iconData.map((item, index) => {
              const isSelected = filters.category === item.category;
              return (
                <div
                  key={index}
                  className="flex flex-col items-center cursor-pointer p-2 min-w-[80px] transition-all duration-300"
                  onClick={() => handleCategoryClick(item.category, item.label)}
                >
                  {/* Circle Card */}
                  <div
                    className={`w-12 h-12 rounded-full flex items-center justify-center bg-gray-100 overflow-hidden transition-all ${
                      isSelected ? "border-2 border-[#6938ef]" : ""
                    }`}
                  >
                    <img
                      src={item.icon}
                      alt={t(item.label)}
                      style={{ color: "#6938ef" }}
                      className="w-7 h-7 object-contain"
                    />
                  </div>

                  {/* Label */}
                  <span className="text-[10px] w-40 mt-2 text-center">
                    {item.label}
                  </span>
                </div>
              );
            })}
          </div>

          <div className="flex flex-col space-y-4">
            <div>
              <label className="text">{t("Price range")}</label>
              <br />
              <br />
              <div className="flex flex-col space-y-2">
                <div className="relative max-w-xl w-full">
                  <DualRangeSlider
                    minValue={filters.selectedPriceRange.min}
                    maxValue={Math.min(filters.selectedPriceRange.max, 3000)}
                    setMinValue={handleMinPriceChange}
                    setMaxValue={handleMaxPriceChange}
                  />

                  <div className="flex items-center justify-between pt-5 space-x-4 text-sm text-gray-700">
                    <div className="text-center">
                      <input
                        type="text"
                        maxLength="5"
                        disabled
                        value={filters.selectedPriceRange.min}
                        className="w-24 px-3 py-1 rounded-full text-center border border-gray-300 bg-gray-50 focus:border-purple-500 focus:outline-none"
                      />
                      <p className="text-xs text-gray-500">{t("Minimum")}</p>
                    </div>

                    <div className="text-center">
                      <input
                        type="text"
                        maxLength="5"
                        disabled
                        value={
                          filters.selectedPriceRange.max > 2999
                            ? "3000+"
                            : filters.selectedPriceRange.max
                        }
                        className="w-24 px-3 py-1 rounded-full text-center border border-gray-300 bg-gray-50 focus:border-purple-500 focus:outline-none"
                      />
                      <p className="text-xs text-gray-500">{t("Maximum")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />

            <div>
              <label className="text mb-4">{t("Location")}</label>
              <select
                className="border border-gray-300 p-3 rounded-md w-full"
                value={filters.selectedCity}
                onChange={handleCityChange}
              >
                <option value="Addis Ababa">{t("Addis Ababa")}</option>
                <option value="Adama">{t("Adama")}</option>
                <option value="Hawasa">{t("Hawassa")}</option>
                <option value="Bahir dar">{t("Bahir dar")}</option>
                <option value="Gonder">{t("Gonder")}</option>
                <option value="Mekele">{t("Mekele")}</option>
                <option value="Arbaminch">{t("Arbaminch")}</option>
                <option value="Hosaena">{t("Hosaena")}</option>
                <option value="Dese">{t("Dese")}</option>
                <option value="Aksum">{t("Aksum")}</option>
                <option value="Dire Dawa">{t("Dire Dawa")}</option>
                <option value="Jijiga">{t("Jijiga")}</option>
                <option value="Harar">{t("Harar")}</option>
                <option value="Samara">{t("Samara")}</option>
                <option value="Shashemene">{t("Shashemene")}</option>
                <option value="Bishoftu">{t("Bishoftu")}</option>
                <option value="Jimma">{t("jimmaa")}</option>
                <option value="Wolaita Sodo">{t("wolayita Sodo")}</option>
                <option value="Bale Robe">{t("Bale Robe")}</option>
                <option value="sheger city">{t("sheger city")}</option>
              </select>
            </div>

            <div className="flex items-center">
              <input
                type="checkbox"
                className="w-4 h-4"
                checked={filters.isNearbySearch}
                onChange={handleNearbySearchToggle}
              />
              <h2 className="text-sm ml-2">{t("Nearby Search")}</h2>
            </div>
            <br />

            <div className="flex w-full">
              <button
                className="bg-white-500 border border-black text-black rounded-md text-sm px-12 py-3 w-auto"
                onClick={resetFilters}
              >
                {t("Clear all")}
              </button>
              <div className="flex-grow"></div>

              <button
                className="bg-blue-500 text-white rounded-md text-sm px-6 py-4"
                style={{ backgroundColor: "#6938ef" }}
                onClick={onApplyFilters}
              >
                {showResults
                  ? `${t("Show All Results")}`
                  : `${t("Show Results")} (${totalCount ?? ""})`}
              </button>
            </div>
          </div>

          <button
            onClick={onClose}
            className="absolute top-2 right-2 font-bold text-red-500 hover:text-gray-700"
          >
            {"Close"} ✕
          </button>
        </div>
      </div>
    </>
  );
};

export default FilterModal;
